// import

import {styled} from '@linaria/react';

// styles

export const CandyRule = styled('hr')`
border: none;
border-radius: 0.5rem;
height: 0.5rem;
max-width: max(27rem, 75%);
margin: 4.5rem auto;
position: relative;
overflow: visible;
background-position: center;
background:
  repeating-linear-gradient(
    -30deg,
    var(--yellow) 0,
    var(--yellow) 0.5rem,
    var(--red) 0.5rem,
    var(--red) 1.0rem,
    var(--blue) 1.0rem,
    var(--blue) 1.5rem
  );
box-shadow:
  inset 0 0 0.25rem var(--black-25),
  0 0 0.25rem var(--black-25);

&[data-text]::after {
  content: attr(data-text);
  position: absolute;
  display: block;
  height: 2rem;
  line-height: 2rem;
  background-color: var(--white);
  padding: 0.5rem 1.5rem;
  top: -1.25rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 500;
  text-align: center;
  box-shadow: 0 0 0.25rem var(--white);
}
`;
